<template>
  <div class="commentAll">
    <div class="wrap">
      <!-- 标题 -->
      <p class="module_title">
				<span>评论</span
        ><span class="close" @click="closeComment"
      ><img
          alt=""
          src="./../../../assets/images/activity/harvard/close.png"
      /></span>
      </p>
      <van-list
          v-model="listLoading"
          :error.sync="listError"
          :finished="listFinished"
          :finished-text="finishText"
          class="vanlist"
          error-text="请求失败，点击重新加载"
          @load="getAllComment(curVideoId)"
      >
        <div
            v-for="(comment, index) in commentAllList"
            :key="comment.id"
            class="commentList"
        >
					<span
              v-lazy:background-image="comment.headImg"
              class="commentAvatars"
          ></span>
          <span class="commentName"
          >{{
              comment.nickName
            }}<span
                v-if="
								userInfo != null &&
								comment.crmId == userInfo.crm_id
							"
                class="myComment"
            >我的评论</span
            ></span
          >
          <div
              ref="commentList"
              class="commentText"
              @click="replyComment(comment, '1')"
          >
            <div class="con" v-text="comment.contents"></div>
            <!-- <span class="expand openCon">... <span @click="expandComment($event,1)">展开</span></span> -->
            <!-- <p class="expand closeCon" @click="expandComment($event,2)"><span>收起</span></p> -->
          </div>
          <div class="bottom">
						<span class="time"
            >{{
                comment.time
              }}<span
                  v-if="
									userInfo != null &&
									comment.crmId == userInfo.crm_id
								"
                  class="delete"
                  @click="dialogToast(comment, '1')"
              >删除</span
              ></span
            >
            <span class="box">
							<span
                  class="commentLike"
                  @click="
									support(
										index,
										'2',
										comment.id,
										comment.crmId,
										comment.id
									)
								"
              >
								<van-icon
                    v-if="!comment.isLikes"
                    color="#999"
                    name="good-job-o"
                />
								<van-icon
                    v-else
                    color="#D7AB3A"
                    name="good-job"
                />
								<span>{{ fomatterNum(comment.likes) }}</span>
							</span>
							<span
                  class="commentBox"
                  @click="replyComment(comment, '1')"
              >
								<img
                    alt=""
                    src="./../../../assets/images/baby/icon1.png"
                />
							</span>
						</span>
          </div>
          <!-- 二级回复 -->
          <div v-if="comment.pageBean != null" class="replyComments">
            <div
                v-for="(
								reply, num
							) in comment.pageBean.content.slice(0, 2)"
                :key="reply.id"
                class="replyCommentList"
            >
              <div class="replyCommentName">
								<span
                    :style="
										reply.crmId == '0'
											? 'color:#8A9EF3'
											: ''
									"
                >{{ reply.nickName }}</span
                ><img
                  src="./../../../assets/images/baby/icon4.png"
              /><span
                  :style="
										reply.replyCrmId == '0'
											? 'color:#8A9EF3'
											: ''
									"
              >{{ reply.replyNickName }}</span
              >
              </div>
              <div
                  class="replyCommentText"
                  @click="replyComment(reply, '2')"
              >
                {{ reply.contents }}
              </div>
              <div class="replyBottom">
								<span class="time"
                >{{
                    reply.time
                  }}<span
                      v-if="
											userInfo != null &&
											reply.crmId == userInfo.crm_id
										"
                      class="delete"
                      @click="dialogToast(reply, '2')"
                  >删除</span
                  ></span
                >
                <span class="box">
									<span
                      class="commentLike"
                      @click="
											secondSupport(
												index,
												num,
												'3',
												reply.parentId,
												reply.crmId,
												reply.id
											)
										"
                  >
										<van-icon
                        v-if="!reply.isLikes"
                        color="#999"
                        name="good-job-o"
                    />
										<van-icon
                        v-else
                        color="#D7AB3A"
                        name="good-job"
                    />
										<span>{{
                        fomatterNum(reply.likes)
                      }}</span>
									</span>
									<span
                      class="commentBox"
                      @click="replyComment(reply, '2')"
                  >
										<img
                        alt=""
                        src="./../../../assets/images/baby/icon1.png"
                    />
									</span>
								</span>
              </div>
            </div>
            <!-- 查看全部评论 -->
            <div
                v-if="comment.pageBean.size > 2"
                class="checkAllCom"
                @click="toReplyCom(comment)"
            >
              查看全部{{ comment.pageBean.size }}条评论
              <van-icon class="arrow" name="arrow"/>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 评论输入框 -->
    <div
        v-show="isFocus"
        class="centerComment"
        @click="isBlur()"
        @touchmove.prevent
        @mousewheel.prevent
    >
      <div class="mask" @click="isBlur('1')"></div>
      <div class="fieldWrap">
        <div class="fieldTop">
					<span class="close" @click="isBlur('1')"
          ><img
              alt=""
              src="./../../../assets/images/activity/harvard/close.png"
          /></span>
          <span class="title">回复：{{ replyNames }}</span>
          <span
              class="button"
              @click="message.length > 0 ? submitAllComment() : ''"
          >提交</span
          >
        </div>
        <div class="fieldCon">
          <van-cell-group class="input-item">
            <van-field
                v-model="message"
                autofocus
                autosize
                maxlength="200"
                placeholder="评论将由小鹤筛选后，所有人可见"
                rows="10"
                type="textarea"
                @input="inputChange"
            />
          </van-cell-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import API from "./../../../utils/axiosApi/harvardApi";
	import { fomatterNum, getCookie, Debounce,globalGoLogin } from "@/assets/js/common.js";
	export default {
		name: "allComment",
		data () {
			return {
				supportType: true,
				commentAllList: [],
				userCrmId: null,
				listLoading: false,
				listFinished: false,
				listError: false,
				finishText: "",
				commentParams: {
					page: 1, size: 25
				},
				curVideoId: null,
				firstFlag: false,
				secondFlag: false,
				commentLen: 0, //评论列表当前数量
				oneConH: 22,//375屏幕下一行评论的高度
				screenHeight: 0,
				userInfo: [],
				commentType: '',
				replyNames: '',
				replyUserInfo: [],
				isFocus: false,
				message: ''
			}
		},
		props: ["commentFirst", "isLogin", 'memberLevel', 'carrierId',],
		watch: {
			commentFirst: function () {
				document.getElementsByClassName("commentAll")[0].scrollTo(0, 0);
				this.commentAllList = [];
				this.commentAllList = this.commentFirst.list;
				if (Math.ceil(this.commentFirst.total / this.commentParams.size) <= 1) {
					this.listFinished = true;
					this.finishText = "——已经到底了哦——";
				} else {
					this.commentParams.page = 2;
					this.finishText = "";
					this.listFinished = false;
				}
			},
			screenHeight (val) {
				this.screenHeight = val;
				let comInput = (58 * (window.innerWidth / 10)) / 37.5;
				if ($("#PublishComment")[0]) {
					comInput = $("#PublishComment")[0].clientHeight
				}
				$("#HFVideo")[0] &&	$(".commentAll").css({
					"height": (val - $("#HFVideo")[0].clientHeight - comInput) + "px",
					"padding-bottom": comInput + "px"
				  });
			}
		},
		mounted () {
			let that = this;
			window.onresize = () => {
				return (() => {
					that.screenHeight = document.body.clientHeight;
				})()
			}
			this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
		},
		methods: {
			fomatterNum, getCookie,
			// 删除评论弹窗
			dialogToast (item, type) {
				this.$dialog.confirm({
					message: '是否删除评论',
					confirmButtonText: '确定',
				}).then(() => {

        this.deleteCom(item, type)
      }).catch(() => {

      })

    },
    inputChange() {
      if (this.message.length >= 1) {
        $('.button').addClass('button2')
      } else if (this.message.length == 0) {
        $('.button').removeClass('button2')
      }
    },
    // 回复提交
    submitAllComment: Debounce(function () {
      this.isFocus = false
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let headImg = this.getCookie('xmh_headimgurl')
      let nickName = this.getCookie('xmh_nickname')
      this.$http.post(this.$http.harvardBaseURL + '/comment/save/reply/ZBvOm0ocQSUykUX5', {},
          {
            carrierId: this.carrierId,
            carrierSpecificId: this.curVideoId,
            contents: this.message,
            crmId: this.userInfo.crm_id,
            headImg: headImg,
            nickName: nickName,
            replyCrmId: this.replyUserInfo.crmId,
            replyNickName: this.replyUserInfo.nickName,
            replyHeadImg: this.replyUserInfo.headImg,
            commentType: this.commentType,
            commentId: this.replyUserInfo.id,
            parentId: this.commentType == '1' ? this.replyUserInfo.id : this.replyUserInfo.parentId
          }, res => {
            if (res.code == '200') {
              this.message = '';
              var page = '1'
              var size = '25'
              var status = true
              $('.button').removeClass('button2')
              var relation = this.carrierId == '1' ? this.commentType == '1' ? 'spfhyj' + this.replyUserInfo.id : 'sphfej' + this.replyUserInfo.id : this.commentType == '1' ? 'wzhfyj' + this.replyUserInfo.id : 'wzhfej' + this.replyUserInfo.id
              this.$toast({
                duration: 2000,
                message: '回复成功',
                context: this
              })
              this.getAllComment(this.curVideoId, page, size, status);
            } else {
              this.$toast({
                duration: 2000,
                message: res.message,
                context: this
              })
            }
          })
    }, 500),
    isBlur(id) {
      if (id == '1') {
        this.isFocus = false;
        $(".PublishComment").css("display", "flex")
      } else if (id == '2') {

      } else if (id == '3') {
      }
    },
    // 回复
    replyComment: function (item, type) {
      if (this.isLogin) {
        // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href })
        globalGoLogin()
      } else {
        // if(type=='first'){ // 一级回复
        //     this.replyNames=item.nickName
        // }else{ // 二级回复
        //     this.replyNames=item.replyNickName
        // }
        $(".PublishComment").css("display", "none")
        this.commentType = type
        this.replyNames = item.nickName
        this.replyUserInfo = item
        this.isFocus = true
      }
    },
    // 删除评论
    deleteCom: function (item, type) {
      this.$http.get(this.$http.harvardBaseURL + '/comment/deleteComment/ZBvOm0ocQSUykUX5', {
        id: item.id,
        crmId: this.userInfo.crm_id,
        type: type
      }, res => {
        if (res.code == '200') {
          var status = true
          var page = '1'
          var size = '25'
          var that = this
          that.$toast({
            duration: 2000,
            message: '删除评论成功',
            context: that
          })
          that.getAllComment(this.curVideoId, page, size, status)
        }
      })
    },
    // 跳转二级回复页
    toReplyCom(item) {
      // type类型 1 哈佛 2 奶娃百科 this.carrierId
      // 文章或视频id  this.articalId
      // 一级评论id item.id
      this.$router.push({
        path: "/replyComment",
        query: {type: this.carrierId, carrierSpecificId: this.curVideoId, first: item.id}
      });
    },
    openAllComment: function (curVideoId) {
      this.userCrmId = JSON.parse(localStorage.getItem("userInfo")) ? JSON.parse(localStorage.getItem("userInfo")).crm_id : null;
      let comInput = (58 * (window.innerWidth / 10)) / 37.5;
      if ($("#PublishComment")[0]) {
        comInput = $("#PublishComment")[0].clientHeight
      }
      $(".commentAll").css({
        "height": ($(document.body).height() - $("#HFVideo")[0].clientHeight - comInput) + "px",
        "padding-bottom": comInput + "px"
      });
      $(".commentAll").slideDown();
      this.$nextTick(() => {
        this.commentLen = this.$refs.commentList.length - 1;
        this.oneConH = parseInt($(".commentText").css("line-height")) * 3;
        var that = this;
        $.each(this.$refs.commentList, function (index, item) {
          let conH = $(item).find(".con")[0].offsetHeight;
          if (conH > that.oneConH) {
            $(item).find(".openCon").css("display", "block");
          }
        });
      });
      this.curVideoId = curVideoId;
    },
    // 获取所有评论
    getAllComment: function (curVideoId, page, size, status) {
      // const {page,size}=this.commentParams;
      var page = status == true ? page : this.commentParams.page
      var size = status == true ? size : this.commentParams.size
      API.getComments({}, {
        page, size,
        data: {
          carrierId: 1,
          crmId: this.userInfo != null ? this.userInfo.crm_id : '',
          carrierSpecificId: curVideoId
        }
      }, res => {
        this.listLoading = false;
        if (res.code == "200") {
          const {list, total} = res.data;
          if (status) { // 添加评论
            this.commentAllList = []
            this.commentAllList = this.commentAllList.concat(list);
          } else {
            this.commentAllList = this.commentAllList.concat(list);
          }
          // this.commentAllList = this.commentAllList.concat(list);
          this.$nextTick(() => {
            if (this.commentAllList.length > 0) {
              let commentLists = this.$refs.commentList.slice(this.commentLen, this.$refs.commentList.length),
                  that = this;
              $.each(commentLists, function (index, item) {
                let conH = $(item).find(".con")[0].offsetHeight;
                if (conH > that.oneConH) {
                  $(item).find(".openCon").css("display", "block");
                }
              });
              this.commentLen = this.$refs.commentList.length - 1;
            }
          });
          if (page >= Math.ceil(total / size) || Math.ceil(total / size) <= 1) {
            this.listFinished = true;
            this.finishText = "——已经到底了哦——";
          } else {
            this.listFinished = false;
            this.commentParams.page += 1;
          }
        } else {
          this.listLoading = false;
          this.listError = true;
        }
      })
    },
    // 关闭所有评论弹窗
    closeComment: function () {
      this.$emit("closeCom");
      this.$emit("getAllComment");
      $(".commentAll").slideUp();
    },
    //一级评论点赞与取消点赞
    support(index, type, parentId, replyCrmId, commentId) {
      if (this.isGoLogin) {
        gio('track', 'hafovideopage_commentgreat', {'member_level': "未登录"});
        this.isLogin();
      } else {
        if (this.firstFlag) return false;
        this.firstFlag = true;
        const {isLikes, likes, id} = this.commentAllList[index];
        let self = this;
        if (isLikes) {
          this.cancelLike(2, parentId, replyCrmId, commentId, function () {
            self.firstFlag = false;
            self.commentAllList[index].likes -= 1;
            if (likes < 0) {
              self.commentAllList[index].likes = 0;
            }
            self.commentAllList[index].isLikes = !isLikes;
          })
        } else {
          // gio('track', 'hafovideopage_commentgreat',{'member_level':this.gread.grade.name});
          this.addLike(id, 2, parentId, replyCrmId, commentId, function () {
            self.firstFlag = false;
            self.commentAllList[index].likes += 1;
            self.commentAllList[index].isLikes = !isLikes;
          })
        }
      }
    },
    //二级评论点赞与取消点赞
    secondSupport(index, num, type, parentId, replyCrmId, commentId) {
      if (this.isGoLogin) {
        gio('track', 'hafovideopage_commentgreat', {'member_level': "未登录"});
        this.isLogin();
      } else {
        if (this.secondFlag) return false;
        this.secondFlag = true;
        const {isLikes, likes, id} = this.commentAllList[index].pageBean.content[num];
        let self = this;
        if (isLikes) {
          this.secondCancelLike(num, 3, parentId, replyCrmId, commentId, function () {
            self.secondFlag = false;
            self.commentAllList[index].pageBean.content[num].likes -= 1;
            if (likes < 0) {
              self.commentAllList[index].pageBean.content[num].likes = 0;
            }
            self.commentAllList[index].pageBean.content[num].isLikes = !isLikes;
          })
        } else {
          // gio('track', 'hafovideopage_commentgreat',{'member_level':this.gread.grade.name});
          this.secondAddLike(num, 3, parentId, replyCrmId, commentId, function () {
            self.secondFlag = false;
            self.commentAllList[index].pageBean.content[num].likes += 1;
            self.commentAllList[index].pageBean.content[num].isLikes = !isLikes;
          })
        }
      }
    },
    // 一级点赞
    addLike(id, type, parentId, replyCrmId, commentId, callback) {
      var nickName = this.getCookie('xmh_nickname');
      var headImg = this.getCookie('xmh_headimgurl');
      API.addLikes({}, {
        carrierId: 1,
        carrierSpecificId: this.curVideoId,
        crmId: this.userInfo.crm_id,
        sourceId: 4,
        type: type,
        isRead: false,
        parentId: parentId,
        status: true,
        nickName: nickName,
        headImg: headImg,
        replyCrmId: replyCrmId,
        commentId: commentId,
      }, res => {
        if (res.code == "200") {
          this.$emit("addFinish");
          callback();
        }
      })
    },
    // 一级取消点赞
    cancelLike(type, parentId, replyCrmId, commentId, callback) {
      API.cancelLikes({}, {
        carrierId: 1,
        carrierSpecificId: this.curVideoId,
        crmId: this.userInfo.crm_id,
        sourceId: 4,
        type: type,
        isRead: false,
        parentId: parentId,
        status: true,
        replyCrmId: replyCrmId,
        commentId: commentId
      }, res => {
        if (res.code == "200") {
          callback();
        }
      })
    },
    // 二级点赞
    secondAddLike(num, type, parentId, replyCrmId, commentId, callback) {
      var nickName = this.getCookie('xmh_nickname');
      var headImg = this.getCookie('xmh_headimgurl');
      API.addLikes({}, {
        carrierId: 1,
        carrierSpecificId: this.curVideoId,
        crmId: this.userInfo.crm_id,
        sourceId: 4,
        type: type,
        isRead: false,
        parentId: parentId,
        status: true,
        nickName: nickName,
        headImg: headImg,
        replyCrmId: replyCrmId,
        commentId: commentId,
      }, res => {
        if (res.code == "200") {
          this.$emit("addFinish");
          callback();
        }
      })
    },
    // 二级取消点赞
    secondCancelLike(num, type, parentId, replyCrmId, commentId, callback) {
      API.cancelLikes({}, {
        carrierId: 1,
        carrierSpecificId: this.curVideoId,
        crmId: this.userInfo.crm_id,
        sourceId: 4,
        type: type,
        isRead: false,
        parentId: parentId,
        status: true,
        replyCrmId: replyCrmId,
        commentId: commentId,
      }, res => {
        if (res.code == "200") {
          callback();
        }
      })
    },
    // 点击展开评论
    expandComment: function (event, handleType) {
      if (handleType == 1) {//展开
        $(event.target).parents(".commentText").css("max-height", "initial");
        $(event.target).parents(".commentText").find(".openCon").css("display", "none");
        $(event.target).parents(".commentText").find(".closeCon").css("display", "block");
      } else {//收起
        $(event.target).parents(".commentText").css("max-height", this.oneConH + "px");
        $(event.target).parents(".commentText").find(".openCon").css("display", "block");
        $(event.target).parents(".commentText").find(".closeCon").css("display", "none");
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "./../../../assets/less/harvard.less";

.commentAll {
  background: @color255;
  // position: fixed;
  // 测试修改视频下拉问题
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  display: none;
  overflow: scroll;

  .wrap {
    padding: 0 12px 85px;
    min-height: 100%;

    .module_title {
      color: @color51;
      font-weight: bold;
      font-size: @fontSize16;
      overflow: hidden;
      margin-left: 12px;

      span {
        width: 50%;
        padding: 15px 0 20px;
        display: block;
        float: left;
      }

      span.close {
        height: 58px;
        display: inline-block;
        float: right;
        text-align: right;
        padding: 0;

        img {
          width: 15px;
          height: 15px;
          margin-top: 15px;
          margin-right: 12px;
        }
      }
    }

    .vanlist {
      min-height: 100%;

      .commentList {
        background: #fff;
        padding: 15px 0;
        // margin: 0 12px;
        border-bottom: 1px solid #f2f2f2;

        .commentAvatars {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          display: inline-block;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          float: left;
        }

        .commentName {
          padding-left: 11px;
          color: #999;
          font-size: 14px;

          .myComment {
            background: #fff8f0;
            color: #d7ab3a;
            font-size: 12px;
            text-align: center;
            padding: 4px 7px;
            margin-left: 5px;
          }
        }

        .commentText {
          padding-top: 10px;
          padding-left: 5px;
          font-size: 14px;
          line-height: 22px;
          overflow: hidden;
          // max-height: 63px;
          color: #333;
          font-weight: 400;
          position: relative;
          word-wrap: break-word;
          word-break: break-all;
          text-overflow: ellipsis;

          .con {
            word-break: break-word;
            white-space: pre-wrap;
          }

          .expand {
            color: @color51;
            font-size: @fontSize14;
            line-height: 22px;
            display: none;
            position: absolute;
            bottom: -3px;
            right: 5px;
            background: #fff;

            span {
              color: #8fa2f3;
            }
          }

          .closeCon {
            width: 100%;
            text-align: right;
            position: inherit;
          }
        }

        .bottom {
          padding-top: 10px;

          .time {
            color: #999;
            font-size: 11px;
            padding-left: 44px;

            .delete {
              color: #999;
              font-size: 11px;
              padding-left: 14px;
            }
          }

          .box {
            float: right;

            .commentLike {
              padding-right: 36px;

              .van-icon {
                font-size: 16px;
                margin-top: 1px;
                vertical-align: text-bottom;
              }

              span {
                color: #999;
                display: inline-block;
                height: 20px;
                margin-left: 3px;
              }
            }

            .commentBox {
              margin-right: 20px;

              img {
                width: 15px;
                height: 15px;
                vertical-align: text-bottom;
              }
            }
          }
        }

        .replyComments {
          margin: 20px 0 0 44px;
          background: #f8f8f8;
          border-radius: 8px;

          .replyCommentList {
            padding: 15px 0;
            margin: 0 16px;
            border-bottom: 1px solid #eaeaea;

            .replyCommentName {
              color: #666;
              font-size: 14px;

              img {
                width: 12px;
                height: 9px;
                padding: 0 6px;
              }
            }

            .replyCommentText {
              padding-top: 5px;
              color: #333;
              font-size: 12px;
              white-space: pre-wrap;
            }

            .replyBottom {
              padding-top: 10px;

              .time {
                color: #999;
                font-size: 11px;

                .delete {
                  color: #999;
                  font-size: 11px;
                  padding-left: 14px;
                }
              }

              .box {
                float: right;

                .commentLike {
                  padding-right: 36px;

                  .van-icon {
                    font-size: 16px;
                    margin-top: 1px;
                    vertical-align: text-bottom;
                  }

                  span {
                    color: #999;
                    display: inline-block;
                    height: 20px;
                    margin-left: 3px;
                  }
                }

                .commentBox {
                  margin-right: 20px;

                  img {
                    width: 15px;
                    height: 15px;
                    vertical-align: text-bottom;
                  }
                }
              }
            }
          }

          .checkAllCom {
            color: #8a9ef3;
            font-size: 12px;
            padding: 10px 0 10px 17px;

            .arrow {
              color: #8a9ef3;
              width: 5px;
              height: 9px;
              padding-left: 7px;
              vertical-align: text-top;
            }
          }
        }
      }
    }
  }

  .centerComment {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: @expertColorMask;
    z-index: 1000;

    .mask {
      min-height: 70%;
    }

    .fieldWrap {
      background: rgba(255, 255, 255, 1);
      border-radius: 8px 8px 0 0;
      width: 100%;
      height: 224px;
      position: fixed;
      bottom: 0;
      left: 0;

      .fieldTop {
        padding-top: 11px;
        display: flex;
        justify-content: space-between;

        .close {
          padding-left: 15px;
          padding-top: 5px;

          img {
            width: 12px;
            height: 12px;
          }
        }

        .title {
          text-align: center;
          color: #333;
          font-size: 16px;
          font-weight: 500;
          padding-left: 25px;
        }

        .button {
          width: 47px;
          height: 26px;
          background: #e2e2e2;
          border-radius: 4px;
          text-align: center;
          line-height: 26px;
          color: #a8a8a8;
          font-size: 12px;
          margin-right: 15px;
        }

        .button2 {
          background: linear-gradient(270deg,
          rgba(215, 168, 92, 1) 0%,
          rgba(231, 196, 121, 1) 100%);
          color: #fff;
        }
      }

      .fieldCon {
        padding: 15px 16px 0;

        .input-item > div {
          width: 100%;
          font-size: @fontSize14;
          min-height: 18px;
          margin-right: auto;
          line-height: 18px;
          color: #333333;
          word-wrap: break-word;
          // overflow-x: hidden;
          // overflow-y: auto;
          -webkit-user-select: text;
          outline: none;
          box-sizing: border-box;
          max-height: 170px;
          padding: 0;
        }

        /deep/ .van-field__control {
          caret-color: #8489ff;
          padding: 10px 0 5px;
          // overflow: scroll;
        }

        .input-item::-webkit-scrollbar {
          width: 0px;
        }

        .van-hairline--top-bottom::after {
          border: 0px;
        }
      }
    }
  }
}
</style>
